export function readCookie(name: string) {
  const cookiePrefix =
    document.documentElement.getAttribute("data-cookie-prefix") || "";
  const expr = new RegExp(`(^| )${cookiePrefix}${name}=([^;]+)(;|$)`);
  const cookie = expr.exec(document.cookie);

  return cookie ? decodeURIComponent(cookie[2]) : null;
}
